<template>
<div>
<div v-title>反欺诈</div>
<div class="content">
	<headerIndex></headerIndex>

	<!-- 轮播banner图 -->
	<div class="swiper-container">
	    <div class="swiper-wrapper"> <!-- style="background: url('{{asset('img/./antiFraud/antiFraud_banner.jpg')}}') center;" -->
	        <div class="swiper-slide swiper-banner" :style="bannerStyle"></div>
	    </div>
	    <!-- 分页器 -->
	    <div class="swiper-pagination"></div>
	</div>
	

	<div class="antiFraud-header">
		<p class="antiFraud-header-tit">反欺诈价服务</p>
		<div class="antiFraud-header-bg"></div>
		<div class="antiFraud-header-box">
			<div class="antiFraud-header-left l">
				<ul>
					<li>
						<span>当事人姓名</span>
						<input type="text" placeholder="请输入当事人名字" v-model="userName">
					</li>
					<li>
						<span>当事人身份证号</span>
						<input type="text" placeholder="请输入当事人身份证号" v-model="user_identity_no" max-length="18">
					</li>
					<li class="countdown-box">
						<span>当事人手机号</span>
						<input type="text" placeholder="请输入当事人手机号" v-model="user_mobile" max-length="16">
	                    <div class="countdown-wrap">
	                        <span class="countdown mobile-gettime" v-show="gettime">
	                            <em id="login-Countdown">{{countdownTime}}</em>秒后重发
	                        </span>
	                        <span class="countdown mobile-getyzm" v-show="getyzm" @click="timer">
	                            {{yzmText}}
	                        </span>
	                    </div>
					</li>
					<li v-if="isError">
						<p class="error-msg">{{errorMsg}}</p>
					</li>
				</ul>
			</div>
			<div class="antiFraud-header-linear l"></div>
			<div class="antiFraud-header-right l">
				<p class="title">个人隐私，当事人必须授权</p>
				<p><input type="text" placeholder="当事人授权查询短信验证码" v-model="rightVerifyCode"></p>
				<p class="antiFraud-header-btn" @click="goAntifraud">{{isAntifraudText}}</p>
			</div>
		</div>
		<p class="antiFraud-header-text">司法案底、执行失信、多头借贷、非银逾期、道德失信、百度黑名单、机构G、机构R、机构M标记黑名单一网打尽，无处藏身</p>
	</div>
	
	<!-- 主体内容 -->
	<div class="antiFraud">
		<!-- 主体内容一 -->
		<div class="antiFraud-first">
			<div class="sq-pattern">
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./antiFraud/sq_pattern_tab4.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">数据整合精加工</h3>
						<p>多平台、多维度缩小无人区 </p>
					</dd>
				</dl>
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./antiFraud/sq_pattern_tab5.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">数据更新实时</h3>
						<p>当事人数据7X24h</p>
					</dd>
				</dl>
				<dl class="sq-pattern-tab">
					<dt>
						<span><img src="./antiFraud/sq_pattern_tab6.png"></span>
					</dt>
					<dd>
						<h3 class="pattern-title">数据更权威</h3>
						<p>逾期追踪最多300家信贷机构 </p>
					</dd>
				</dl>
			</div>
		</div>

		<!-- 主体内容二 -->
		<div class="antiFraud-second">
			<p class="section-title-fff pt86 pb20">
				<span>资信透视</span>
				<span>骗贷拦截</span> 
				<span>你关心的</span> 
				<span>这里都有</span>       
			</p>
			<p class="section-word-fff">随着金融机构业务规模的迅猛增长和业务品种的日益丰富，互联网金融带来的风险层出不穷</p>
			<p class="section-word-fff">交易场景复杂 ，追踪记录难度高，缺乏风控模型，风控经验等。更重要的是每家企业对指标的定义不同</p>
			<p class="section-word-fff">造成数据存在大量的重复、矛盾、漏掉。快贷云致力于数据整合、实时更新当事人情况，黑名单用户查询更快、更全、更准，让欺诈无处藏身</p>

			<div class="antiFraud-function w1120">
				<p class="antiFraud-highlight-linear"></p>
				<ul class="antiFraud-function-left">
					<li class="antiFraud-function-li active" @mouseover="animateAntiFraud(0)">司法、失信及其他行政预警
						<span class="linear6" style="display: block;"><img src="./antiFraud/linear6.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(1)">甄别虚假申请，欺诈风险
						<span class="linear7"><img src="./antiFraud/linear7.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(2)">贷款逾期追踪
						<span class="linear8"><img src="./antiFraud/linear8.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(3)">检测用户互联网行为
						<span class="linear9"><img src="./antiFraud/linear9.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(4)">手机号预警异常通话扫描
						<span class="linear10"><img src="./antiFraud/linear10.png"></span></li>
				</ul>
				<ul class="antiFraud-function-right">
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(5)">高风险级别，黑名单检测
						<span class="linear1"><img src="./antiFraud/linear1.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(6)">贷前、贷中、贷后多头侦测
						<span class="linear2"><img src="./antiFraud/linear2.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(7)">央行征信查询，独此一家
						<span class="linear3"><img src="./antiFraud/linear3.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(8)">社保缴费、公积金查询
						<span class="linear4"><img src="./antiFraud/linear4.png"></span>
					</li>
					<li class="antiFraud-function-li" @mouseover="animateAntiFraud(9)">用户失联风险预警
						<span class="linear5"><img src="./antiFraud/linear5.png"></span>
					</li>
				</ul>
			</div>
		</div>

		<!-- 主体内容三  说明  -->
		<div class="antiFraud-third w1120">
			<p class="section-title pt86 pb20">反欺诈数据说明</p>
			<p class="section-word">情报获取、风险识别、批贷决策、货中巡查、贷后预警你关心的，这里都有，超出你所想</p>
			<div class="data-declaration">
				<dl>
					<dt><img src="./antiFraud/data_declaration.png" style="width: 80px;"></dt>
					<dd>
						<p>甄别骗贷，控制源头</p>
						<p>复合审查，心里有底不吃亏</p>
					</dd>
				</dl>
				<dl>
					<dt><img src="./antiFraud/data_declaration2.png" style="height:87px;"></dt>
					<dd>
						<p>贷后预警，把控风险</p>
						<p>逾期追踪，贷后管理智能化</p>
					</dd>
				</dl>
			</div>
			<div class="data-declaration-text">截止目前快贷反欺诈引擎已集成接入国内银行、非银行信贷、消费金融、供应链金融、互联网金融等主流平台指定使用的大数据如融360大数据、百度大数据、芝麻征信大数据、全国社保缴费查询、全国公积金缴费查询引擎、芝麻征信以及民间借贷数据共享机构R、共享机构G和全国最高法、最高检信息披露平台的汇法网、法海网。</div>
		</div>

		<!-- 主体内容四  案例 -->
		<div class="antiFraud-fourth">
			<p class="section-title-fff pt86 pb20">反欺诈数据案例</p>
			<p class="section-word-fff">通过身份证号、名字、手机号三个唯一识别信息从上述征信平台扫描数据</p>
			<p class="section-word-fff">并对各平台的数据进行交叉验证，经过清洗、整合、分析和翻译，判断借款申请人的的风险点，向金融机构提供风险决策的数据支持</p>
			<div class="data-case"><img src="./antiFraud/antiFraud_case_img.png"></div>
		</div>
	</div>
	

	<div class="layer-box" v-show="isLayer">
		<div class="mask2"></div>
		<div class="layer">
			<h2 class="layer-title">请输入图形验证码</h2>
			<div class="layer-content">
	            <div class="layer-inputwraper">
	                <input type="text" placeholder="请输入图形中的字符" id="alertMsgCode" maxlength="4" v-model="img_code"/>
	                <img :src="img_url"  width="80" height="39" border="0" @click="changeImgSrc">
	            </div>
	            <p class="layer-error-msg">{{layerMsg}}</p>
            </div>
            <div class="layer-button">
            	<p @click="closeLayer">取消</p>
            	<p @click="imgLayerSure">确定</p>
            </div>
		</div>
	</div>

	<div class="credit-layer" v-show="isCredit">
		<div class="mask2"></div>
		<div class="credit-detail">
			<span class="closeIcon">
				<span>个人信贷风险评分</span>
				<i @click="closeCredit">X</i>
			</span>
			<table border="1" style="margin-top: 50px;">
				<!-- <tr>
					<th colspan="2">个人信贷风险评分</th>
				</tr> -->
				<tr>
					<td>真实姓名：{{userName}}</td>
					<td>身份证号：{{(user_identity_no).toString().replace(/(\d{6})\d{8}(\d{4})/, '$1******$2')}}</td>
				</tr>
				<tr>
					<td>手机号码：{{(user_mobile).toString().replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}</td>
					<td>生成时间：{{create_time}}</td>
				</tr>
			</table>

			<div v-for="item in data">
				<div class="credit-detail-part" v-for="item2 in item.items_data">
					<h2>
						<i class="organType"><img :src="item2.icon"></i>
						{{item2.title}}
					</h2>
					<div style="padding: 20px 0;">
						<div v-if=" item2.items == ''">
							<dl>
								<dt>类型：</dt>
								<dd>该用户不在黑名单内</dd>
							</dl>
						</div>
						<div v-for="item3 in item2.items" class="credit-part2" v-else>
							<!-- <table border="1">
								<tr style="width:50%;" v-for="(item4,index4) in item3.items">
									<td style="width:300px;">{{item4.name}}</td>
									<td style="width:300px;" v-if="item4.content">{{item4.content}}</td>
									<td style="width:300px;" v-else>--</td>
								</tr>
							</table> -->
							<dl v-for="(item4,index4) in item3.items">
								<dt>{{item4.name}}：</dt>
								<dd v-if="item4.content">{{item4.content}}</dd>
								<dd v-else>--</dd>
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<footerIndex></footerIndex>

</div>

</div>
</template>

<script type="text/ecmascript-6">
	import './antiFraud.css'
	import footerIndex from '../common/footerIndex.vue'
	import headerIndex from '../common/header.vue'
	export default{
		data(){
			return {
				bannerStyle:{
		            backgroundImage: "url(" + require("./antiFraud/antiFraud_banner.jpg") + ")",
		            backgroundRepeat: "no-repeat",
		            backgroundSize: "auto 100%",
		            backgroundPosition: "center",
				},
				getyzm: true,
				gettime:false,
				isLayer:false,
				isError:false,
				isCredit:false,
				isAntifraud:true,
				isAntifraudText:'扫描',
				userName: '',
				user_identity_no: '',
				user_mobile: '',
				rightVerifyCode: '',
				countdownTime: '',
				yzmText: '获取验证码',
				img_code:'',
				errorMsg:'',
				csrfToken:'',
				img_url:'',
				layerMsg:'',
				creditArr:[],
				data:{},
				create_time:'',
			}
		},
		components: {
			footerIndex,
			headerIndex
		},
		methods:{
			animateAntiFraud,
			timer,
			changeImgSrc,
			closeLayer,
			imgLayerSure,
			goAntifraud,
			closeCredit,
			openLayer,
			login
		},
		mounted(){
		}
	}

	function login(){
		// location.href = 'http://admin.test.senqiang.cn';
		location.href = this.$store.state.adminUrl;
	}


	function openLayer(){
		this.$message({
			showClose: true,
			message: '正在努力开发中,敬请期待',
			type: 'success'
		});
	}

	function animateAntiFraud(num){
		var animateArr = document.getElementsByClassName("antiFraud-function-li");
		for(var i = 0; i<animateArr.length;i++){
			if( i == num){
				animateArr[i].classList.add("active");
				animateArr[i].children[0].style.display="block";
			}else{
				animateArr[i].classList.remove("active");
				animateArr[i].children[0].style.display="none";
			}
		}
	}

	//倒计时
	let timers=59;
	let timer1;
	function timer(){ 
		if(!this.user_mobile){
			this.isError = true;
			this.errorMsg = '请填写手机号';
			return false;
		}
	    //获取短信验证码
	    this.$http.get(this.$store.state.apiUrl+'/share/sms?phone='+this.user_mobile).then((response) => {
	        response = response.body;
	        console.log(response)
	        if(response.code == 0){
	            let _this = this;
	        	_this.isError = false;
	            _this.gettime = true;
	            _this.getyzm = false;
	            timer1 = setInterval(function(){
	                if(timers<10){
	                    _this.countdownTime = "0"+ timers--;
	                }else{
	                    _this.countdownTime = timers--;
	                }
	                if(timers==-1){
	                    _this.countdownTime = 60;
	                    _this.gettime = false;
	                    _this.getyzm = true;
	                    _this.yzmText = "重新获取";
	                    timers=59;
	                    clearInterval(timer1);
	                } 
	            },1000);
	        }else if(response.code == 2066){
	        	this.isError = false;
	            this.isLayer = true;
	            this.layerMsg = '';
	            this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	                response = response.body;
	                if(response.code == 0){
	                    this.csrfToken = response.data;
	                    this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	                }else{
	                    console.log('请求失败')
	                }
	            })
	        }else if(response.code == 2061){
	        	this.isError = true;
	        	this.errorMsg = '您获取短信验证码过于频繁，请明天再试';
	        }
	    })
	}

	//图形验证码确认
	function imgLayerSure(){
	    if(this.img_code == ''){
	        this.layerMsg='图形验证码不能为空';
	        return false;
	    }
	    this.$http.get(this.$store.state.apiUrl+'/share/sms',{
	        params:{
	            image:this.img_code,
	            phone: this.user_mobile,
	            key: this.csrfToken,
	        }
	    }).then((response) => {
	        response = response.body;
	        console.log(response);
	        if(response.code == 0){
	            this.isLayer = false;
	            let _this = this;
	            _this.gettime = true;
	            _this.getyzm = false;
	            timer1 = setInterval(function(){
	                if(timers<10){
	                    _this.countdownTime = "0"+ timers--;
	                }else{
	                    _this.countdownTime = timers--;
	                }
	                if(timers==-1){
	                    _this.countdownTime = 60;
	                    _this.gettime = false;
	                    _this.getyzm = true;
	                    _this.yzmText = "重新获取";
	                    timers=59;
	                    clearInterval(timer1);
	                } 
	            },1000);
	        }else if(response.code==2067){
	            this.layerMsg='图形验证码有误';
	            this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	                response = response.body;
	                if(response.code == 0){
	                    this.csrfToken = response.data;
	                    this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	                }else{
	                    console.log('请求失败')
	                }
	            })
	            return false;
	        }
	    })
	}

	// 改变图形验证码
	function changeImgSrc(){
	    this.$http.get(`${this.$store.state.apiUrl}/borrower/user/getCsrfToken`).then((response) => {
	        response = response.body;
	        if(response.code == 0){
	            this.csrfToken = response.data;
	            this.img_url = `${this.$store.state.apiUrl}/borrower/user/getImgCode?csrfToken=${this.csrfToken}`;
	        }else{
	            console.log('请求失败')
	        }
	    })
	}

	// 关闭弹框
	function closeLayer(){
		this.isLayer = false;
	}

	function goAntifraud(){
		if(this.isAntifraud){
			var user_identity_no_reg = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/gi,
				user_mobile_reg = /^((\+86)|(86))?[1][3456789][0-9]{9}$/gi;
			if(this.userName == '' || this.userName == '请输入姓名'){
				this.isError = true;
				this.errorMsg = '请填写正确的姓名';
			}else if(!user_identity_no_reg.test(this.user_identity_no)){
				this.isError = true;
				this.errorMsg = '请填写正确的身份证号码';
				return false;
			}else if(!user_mobile_reg.test(this.user_mobile)){
				this.isError = true;
				this.errorMsg = '请填写正确的手机号码';
				return false;
			}else{
				this.isAntifraud = false;
				this.isAntifraudText = '扫描中';
		        this.$http.get(this.$store.state.apiUrl+'/share/verifySmsCode?phone='+this.user_mobile+'&code='+this.rightVerifyCode).then((response) => {
		            response = response.body;
		            console.log(response)
		            if(response.code == 0){
		            	this.isAntifraud = true;
		            	this.isAntifraudText = '扫描';
		                console.log('成功啦');
		                var obj = {};
						obj.user_identity_no = this.user_identity_no;
						obj.user_name = this.userName;
						obj.user_mobile = this.user_mobile;
						obj.loan_user_type = '1';
						this.creditArr.push(obj);
						this.$http.post(this.$store.state.apiUrl+'/credit/SaasCreditUserBlackList',{},{
							params:{
								'userList':JSON.stringify(this.creditArr),
							}
						}).then((response) => {
							console.log(response)
							response = response.body;
							if(response.code == 0){
								this.data = response.data.data;
								this.isCredit = true;
								this.isError = false;
								for(var i in this.data){
									this.create_time = this.data[i].create_time;
								}
							}else{
								this.isError = true;
		            			this.errorMsg = response.message;
							}
						})
		            }else{
		            	this.isAntifraud = true;
		            	this.isAntifraudText = '扫描';
		            	this.isError = true;
		            	this.errorMsg = response.message;
		            }
		        })
		    }
		}


			/*var obj = {};
			obj.user_identity_no = '133030197305176229';
			obj.user_name = '王秀芬';
			obj.user_mobile = '18706127897';
			obj.loan_user_type = '1';
			this.creditArr.push(obj);
			this.$http.post(this.$store.state.apiUrl+'/credit/blackList',{},{
				params:{
					'userList':JSON.stringify(this.creditArr),
				}
			}).then((response) => {
				console.log(response)
				response = response.body;
				if(response.code == 0){
					this.data = response.data.data;
					this.isCredit = true;
					console.log(this.data);
				}
			})*/
	}

	function closeCredit(){
		console.log(11111)
		this.isCredit = false;
	}

</script>
<style>
	.countdown-box{
		position: relative;
	}
	.countdown-wrap{
		position: absolute;
		right: 0;
		top: 0;
	} 
	.countdown-wrap .countdown{
        width: 100%;
        font-size: 16px;
        color: #fff;
        text-align: center;
        height: 34px;
        line-height: 34px;
        background: #0ea3f0;
        border-radius: 0.08rem;
        display: inline-block;
        cursor: pointer;
    }
    .countdown-wrap .mobile-gettime{
    	background: #ccc;
    }

    .credit-detail{
    	width: 70%;
    	height: 80%;
    	position: fixed;
    	top: 100px;
    	left: 15%;
    	background: #fff;
    	z-index: 999;
    	padding: 0 50px;
    	overflow-y: scroll;
    }
    .credit-detail table{
    	width: 100%;
    	text-align: center;
    	border: 1px solid #ccc;
    	color: #797979;
    	font-size: 14px;
    	margin-bottom: 20px;
    }
    .credit-detail table tr {
	    height: 38px;
	    line-height: 38px;
	}
	.credit-detail h2{
	    color: #444444;
	    font-size: 16px;
	    height: 42px;
	    line-height: 42px;
	    border-bottom: 1px solid #dedede;
	}
	.organType{
		width: 24px;
		height: 24px;
	}
	.organType img{
		width: auto;
		height: 24px;
		vertical-align: middle;
	}
	.credit-detail-part{
		/*background: #eee;*/
		margin-bottom: 20px;
		padding-left: 20px;
		font-size: 16px;
		line-height: 36px;
	}
	.credit-part2{
		/*border-bottom: 1px dashed #dedede;*/
		padding: 16px 0;
		overflow: hidden;
	}
	.credit-detail-part dt{
		color: #898989;
		display: inline-block;
		min-width: 120px;
		/*border-right: 1px solid #dedede;*/
	}
	.credit-detail-part dd{
		display: inline-block;
		padding-left: 16px;
	}
	.closeIcon{
		width: 100%;
		display: inline-block;
		text-align: center;
		padding-top: 20px;
	}
	.closeIcon span{
		display: inline-block;
		padding: 10px;
		font-size: 20px;
	}
	.closeIcon i{
		display: inline-block;
		float: right;
		padding: 10px;
		transform: scale(1.2);
		cursor: pointer;
	}
	.credit-part2 dl{
		/*width: 50%;
		float: left;
		border-bottom: 1px solid #dedede;*/
	}
</style>


// WEBPACK FOOTER //
// src/components/homepageComponent/antiFraud.vue